import cn from 'classnames';
import { ReactNode } from 'react';
import { useField } from 'formik';
import Text from '@/components/common/Text/Text';

import './CheckboxField.style.scss';

// This is used with Formik and form data

// If you require a vanilla HTML/React checkbox with basic toggling use:
// common/CheckBox

type CheckboxFieldProps = {
  name: string;
  label: ReactNode;
  className?: string;
  onClick?: (checked: boolean) => void;
};

function CheckboxField(props: CheckboxFieldProps) {
  const { name, label, className, onClick } = props;
  const [field, meta /*, helpers */] = useField({ name });

  return (
    <div className={cn('CheckboxField', className)}>
      <label className='cursor'>
        <input
          className={cn(className, { Error: meta.touched && meta.error })}
          type='checkbox'
          checked={field.value}
          onClick={(e) => onClick?.(e.currentTarget.checked)}
          {...field}
        />
        {label}
      </label>
      {meta.touched && meta.error && (
        <div className='CheckboxField-error'>
          <Text className='CheckboxField-error-text'>{meta.error}</Text>
        </div>
      )}
    </div>
  );
}

export default CheckboxField;
